// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Lanren_wrapper__3gRQo","grow":"Lanren_grow__23c1F"};